import { Component, OnInit } from '@angular/core';
import { ReqService } from '@core/services/req.service';
import { MbIcon } from '@am/moebius';
import { NgClass } from '@angular/common';

@Component({
    selector: 'am-disney-benefits',
    templateUrl: './disney-benefits.component.html',
    styleUrls: ['./disney-benefits.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        MbIcon,
    ],
})
export class DisneyBenefitsComponent implements OnInit {
  public benefitsDisney = [
    'Entrada temprana a los parques.',
    'Traslado gratuito a los parques.',
    'Entretenimiento en el resort.',
    'Fácil acceso a los parques.',
    'Estacionamiento sin costo.',
  ];

  public brand = 'almundo';

  constructor(private reqService: ReqService) {}

  public ngOnInit(): void {
    this.brand = this.reqService.getBrand();
  }
}
